import React from 'react'
import { NavLink } from 'react-router-dom';

export default function ResponseCode() {
	const data = [
		{
			responseCode: 'General Error',
			responseDescription:
				'Transaction has failed. You may start a new charge.',
		},
		{
			responseCode: 'PENDING',
			responseDescription: 'Transaction is being processed.',
		},
		{
			responseCode: 'OTP_VALIDATION',
			responseDescription:
				'OTP is required from the customer to complete the transaction.',
		},
		{
			responseCode: 'VBV_VALIDATION',
			responseDescription:
				'3DS authentication is required from the customer to complete the transaction.',
		},
		{
			responseCode: 'FAILED',
			responseDescription: 'Transaction failed. No remedy.',
		},
		{
			responseCode: 'SUCCESSFUL',
			responseDescription:
				'Transaction is successful. Give value after checking to see that all is in order.',
		},
	];
	return (
		<main className="pt-20 px-1 pb-20 2xl:px-10">
			<div>
				<h1 className="mb-10">Response Code</h1>
				<div className="w-100 h-[1px] bg-gray-400" />
			</div>
			<div className="my-10 space-y-2">
				<div>
					<p className="">
						Transactions are valid for 30mins. Any response you get after 30
						mins should be considered the final response.
					</p>
				</div>
				<div>
					<p className="">
						However, customers can retry the same transaction till it expires,
						so response codes can change till the transaction is successful,
						fails, or it expires.
					</p>
				</div>
			</div>

			<table className="table-auto w-full border border-slate-400 border-spacing-x-2">
				<thead>
					<tr>
						<th className="border-b dark:border-slate-600 font-medium p-1 md:p-4 md:pl-8 pt-3 pb-3 text-left">
							Response Code
						</th>
						<th className="border-b dark:border-slate-600 font-medium p-1 md:p-4 md:pl-8 pt-3 pb-3 text-left">
							Respoonse Description
						</th>
					</tr>
				</thead>
				{data.map((val) => (
					<tbody className="bg-white dark:bg-slate-800" key={val.responseCode}>
						<tr>
							<td className="border-b border-r-2 border-slate-100 dark:border-slate-700 p-1 md:p-4 md:pl-8 text-slate-500">
								{val.responseCode}
							</td>
							<td className="border-b border-slate-100 dark:border-slate-700 p-1 md:p-4 md:pl-8 text-slate-500">
								{val.responseDescription}
							</td>
						</tr>
					</tbody>
				))}
			</table>

			<div className="text-[12px] mt-10">WHAT&apos;S NEXT</div>
			<div>
				<NavLink to="/test-payment">
					<div className="inline-flex items-center space-x-2">
						<p className="text-[#083d8c] text-[16px]">Test Payment</p>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth={1.5}
							stroke="currentColor"
							className="w-6 h-6"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
							/>
						</svg>
					</div>
				</NavLink>
			</div>
		</main>
	);
}
